import React from 'react';

import GermanyFlagImg from 'assets/images/pages/plans/flag-germany.png';

import classes from './TrustHighlights.module.scss';


const highlights = [
    {
        title: '96%',
        subtitle: 'learners satisfaction',
        description: 'Rated highly by Pharmuni learners',
    },
    {
        title: 'Since 2017',
        subtitle: 'Supporting learners',
        description: 'Built by Zamann Pharma Support',
    },
    {
        image: GermanyFlagImg.src,
        imageAlt: 'Germany Flag',
        subtitle: 'Made in Germany',
        description: 'Created for the global life sciences industry',
    },
    {
        title: '80K+',
        subtitle: 'Pharma Professionals',
        description: 'Across pharma and life sciences',
    },
];

const TrustHighlights = () => {
    return (
        <div className={classes['highlights']}>
            {highlights.map((highlight) => (
                <div className={classes['item']} key={highlight.subtitle}>
                    {highlight.image
                        ? <img className={classes['flag']} src={highlight.image} alt={highlight.imageAlt} />
                        : <div className={classes['title']}>{highlight.title}</div>
                    }
                    <div className={classes['subtitle']}>{highlight.subtitle}</div>
                    <div className={classes['description']}>{highlight.description}</div>
                </div>
            ))}
        </div>
    );
};

export default TrustHighlights;
